'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FETCH_TAGS_REQUEST = exports.FETCH_TAGS_REQUEST = 'FETCH_TAGS_REQUEST';
var FETCH_TAGS_SUCCESS = exports.FETCH_TAGS_SUCCESS = 'FETCH_TAGS_SUCCESS';
var FETCH_TAGS_FAILURE = exports.FETCH_TAGS_FAILURE = 'FETCH_TAGS_FAILURE';

var FETCH_CATEGORIES_REQUEST = exports.FETCH_CATEGORIES_REQUEST = 'FETCH_CATEGORIES_REQUEST';
var FETCH_CATEGORIES_SUCCESS = exports.FETCH_CATEGORIES_SUCCESS = 'FETCH_CATEGORIES_SUCCESS';
var FETCH_CATEGORIES_FAILURE = exports.FETCH_CATEGORIES_FAILURE = 'FETCH_CATEGORIES_FAILURE';

var FETCH_ARTICLE_REQUEST = exports.FETCH_ARTICLE_REQUEST = 'FETCH_ARTICLE_REQUEST';
var FETCH_ARTICLE_SUCCESS = exports.FETCH_ARTICLE_SUCCESS = 'FETCH_ARTICLE_SUCCESS';
var FETCH_ARTICLE_FAILURE = exports.FETCH_ARTICLE_FAILURE = 'FETCH_ARTICLE_FAILURE';

var FETCH_RELATED_ARTICLES_REQUEST = exports.FETCH_RELATED_ARTICLES_REQUEST = 'FETCH_RELATED_ARTICLES_REQUEST';
var FETCH_RELATED_ARTICLES_SUCCESS = exports.FETCH_RELATED_ARTICLES_SUCCESS = 'FETCH_RELATED_ARTICLES_SUCCESS';
var FETCH_RELATED_ARTICLES_FAILURE = exports.FETCH_RELATED_ARTICLES_FAILURE = 'FETCH_RELATED_ARTICLES_FAILURE';

var FETCH_ARTICLES_BY_GROUP_UUID_REQUEST = exports.FETCH_ARTICLES_BY_GROUP_UUID_REQUEST = 'FETCH_ARTICLES_BY_GROUP_UUID_REQUEST';
var FETCH_ARTICLES_BY_GROUP_UUID_SUCCESS = exports.FETCH_ARTICLES_BY_GROUP_UUID_SUCCESS = 'FETCH_ARTICLES_BY_GROUP_UUID_SUCCESS';
var FETCH_ARTICLES_BY_GROUP_UUID_FAILURE = exports.FETCH_ARTICLES_BY_GROUP_UUID_FAILURE = 'FETCH_ARTICLES_BY_GROUP_UUID_FAILURE';

var FETCH_FEATURE_ARTICLES_REQUEST = exports.FETCH_FEATURE_ARTICLES_REQUEST = 'FETCH_FEATURE_ARTICLES_REQUEST';
var FETCH_FEATURE_ARTICLES_SUCCESS = exports.FETCH_FEATURE_ARTICLES_SUCCESS = 'FETCH_FEATURE_ARTICLES_SUCCESS';
var FETCH_FEATURE_ARTICLES_FAILURE = exports.FETCH_FEATURE_ARTICLES_FAILURE = 'FETCH_FEATURE_ARTICLES_FAILURE';

var FETCH_INDEX_ARTICLES_REQUEST = exports.FETCH_INDEX_ARTICLES_REQUEST = 'FETCH_INDEX_ARTICLES_REQUEST';
var FETCH_SECTIONS_FEATURED_SUCCESS = exports.FETCH_SECTIONS_FEATURED_SUCCESS = 'FETCH_SECTIONS_FEATURED_SUCCESS';
var FETCH_SECTIONS_FEATURED_FAILURE = exports.FETCH_SECTIONS_FEATURED_FAILURE = 'FETCH_SECTIONS_FEATURED_FAILURE';
var FETCH_LATEST_POSTS_SUCCESS = exports.FETCH_LATEST_POSTS_SUCCESS = 'FETCH_LATEST_POSTS_SUCCESS';
var FETCH_LATEST_POSTS_FAILURE = exports.FETCH_LATEST_POSTS_FAILURE = 'FETCH_LATEST_POSTS_FAILURE';
var FETCH_CHOICES_SUCCESS = exports.FETCH_CHOICES_SUCCESS = 'FETCH_CHOICES_SUCCESS';
var FETCH_CHOICES_FAILURE = exports.FETCH_CHOICES_FAILURE = 'FETCH_CHOICES_FAILURE';
var FETCH_INDEX_ARTICLES_FAILURE = exports.FETCH_INDEX_ARTICLES_FAILURE = 'FETCH_INDEX_ARTICLES_FAILURE';

var SET_PROGRESS_PRECENTAGE = exports.SET_PROGRESS_PRECENTAGE = 'SET_PROGRESS_PRECENTAGE';
var SET_PAGE_TYPE = exports.SET_PAGE_TYPE = 'SET_PAGE_TYPE';
var SET_PAGE_TITLE = exports.SET_PAGE_TITLE = 'SET_PAGE_TITLE';
var SET_ARTICLE_TOPIC_LIST = exports.SET_ARTICLE_TOPIC_LIST = 'SET_ARTICLE_TOPIC_LIST';

var FETCH_SECTION_LIST_SUCCESS = exports.FETCH_SECTION_LIST_SUCCESS = 'FETCH_SECTION_LIST_SUCCESS';
var FETCH_SECTION_LIST_REQUEST = exports.FETCH_SECTION_LIST_REQUEST = 'FETCH_SECTION_LIST_REQUEST';
var FETCH_SECTION_LIST_FAILURE = exports.FETCH_SECTION_LIST_FAILURE = 'FETCH_SECTION_LIST_FAILURE';

var FETCH_SEARCH_RESULT_REQUEST = exports.FETCH_SEARCH_RESULT_REQUEST = 'FETCH_SEARCH_RESULT_REQUEST';
var FETCH_SEARCH_RESULT_SUCCESS = exports.FETCH_SEARCH_RESULT_SUCCESS = 'FETCH_SEARCH_RESULT_SUCCESS';
var FETCH_SEARCH_RESULT_FAILURE = exports.FETCH_SEARCH_RESULT_FAILURE = 'FETCH_SEARCH_RESULT_FAILURE';

var FETCH_YOUTUBE_PLAYLIST_REQUEST = exports.FETCH_YOUTUBE_PLAYLIST_REQUEST = 'FETCH_YOUTUBE_PLAYLIST_REQUEST';
var FETCH_YOUTUBE_PLAYLIST_SUCCESS = exports.FETCH_YOUTUBE_PLAYLIST_SUCCESS = 'FETCH_YOUTUBE_PLAYLIST_SUCCESS';
var FETCH_YOUTUBE_PLAYLIST_FAILURE = exports.FETCH_YOUTUBE_PLAYLIST_FAILURE = 'FETCH_YOUTUBE_PLAYLIST_FAILURE';

var FETCH_EVENT_REQUEST = exports.FETCH_EVENT_REQUEST = 'FETCH_EVENT_REQUEST';
var FETCH_EVENT_SUCCESS = exports.FETCH_EVENT_SUCCESS = 'FETCH_EVENT_SUCCESS';
var FETCH_EVENT_FAILURE = exports.FETCH_EVENT_FAILURE = 'FETCH_EVENT_FAILURE';

var FETCH_TOPICS_REQUEST = exports.FETCH_TOPICS_REQUEST = 'FETCH_TOPICS_REQUEST';
var FETCH_TOPICS_SUCCESS = exports.FETCH_TOPICS_SUCCESS = 'FETCH_TOPICS_SUCCESS';
var FETCH_TOPICS_FAILURE = exports.FETCH_TOPICS_FAILURE = 'FETCH_TOPICS_FAILURE';

var FETCH_TOPIC_REQUEST = exports.FETCH_TOPIC_REQUEST = 'FETCH_TOPIC_REQUEST';
var FETCH_TOPIC_SUCCESS = exports.FETCH_TOPIC_SUCCESS = 'FETCH_TOPIC_SUCCESS';
var FETCH_TOPIC_FAILURE = exports.FETCH_TOPIC_FAILURE = 'FETCH_TOPIC_FAILURE';

var FETCH_IMAGES_REQUEST = exports.FETCH_IMAGES_REQUEST = 'FETCH_IMAGES_REQUEST';
var FETCH_IMAGES_SUCCESS = exports.FETCH_IMAGES_SUCCESS = 'FETCH_IMAGES_SUCCESS';
var FETCH_IMAGES_FAILURE = exports.FETCH_IMAGES_FAILURE = 'FETCH_IMAGES_FAILURE';

var FETCH_AUDIOS_REQUEST = exports.FETCH_AUDIOS_REQUEST = 'FETCH_AUDIOS_REQUEST';
var FETCH_AUDIOS_SUCCESS = exports.FETCH_AUDIOS_SUCCESS = 'FETCH_AUDIOS_SUCCESS';
var FETCH_AUDIOS_FAILURE = exports.FETCH_AUDIOS_FAILURE = 'FETCH_AUDIOS_FAILURE';

var PASS_ANSWER_REQUEST = exports.PASS_ANSWER_REQUEST = 'PASS_ANSWER_REQUEST';
var PASS_ANSWER_SUCCESS = exports.PASS_ANSWER_SUCCESS = 'PASS_ANSWER_SUCCESS';
var PASS_ANSWER_FAILURE = exports.PASS_ANSWER_FAILURE = 'PASS_ANSWER_FAILURE';

var FETCH_QUESTIONNAIRE_REQUEST = exports.FETCH_QUESTIONNAIRE_REQUEST = 'FETCH_QUESTIONNAIRE_REQUEST';
var FETCH_QUESTIONNAIRE_SUCCESS = exports.FETCH_QUESTIONNAIRE_SUCCESS = 'FETCH_QUESTIONNAIRE_SUCCESS';
var FETCH_QUESTIONNAIRE_FAILURE = exports.FETCH_QUESTIONNAIRE_FAILURE = 'FETCH_QUESTIONNAIRE_FAILURE';

var RESET_QUESTIONNAIRE_REQUEST = exports.RESET_QUESTIONNAIRE_REQUEST = 'RESET_QUESTIONNAIRE_REQUEST';
var RESET_QUESTIONNAIRE_SUCCESS = exports.RESET_QUESTIONNAIRE_SUCCESS = 'RESET_QUESTIONNAIRE_SUCCESS';
var RESET_QUESTIONNAIRE_FAILURE = exports.RESET_QUESTIONNAIRE_FAILURE = 'RESET_QUESTIONNAIRE_FAILURE';

var GO_NEXT_QUESTION_REQUEST = exports.GO_NEXT_QUESTION_REQUEST = 'GO_NEXT_QUESTION_REQUEST';
var GO_NEXT_QUESTION_SUCCESS = exports.GO_NEXT_QUESTION_SUCCESS = 'GO_NEXT_QUESTION_SUCCESS';
var GO_NEXT_QUESTION_FAILURE = exports.GO_NEXT_QUESTION_FAILURE = 'GO_NEXT_QUESTION_FAILURE';

var FETCH_TWITTER_TIMELINE_REQUEST = exports.FETCH_TWITTER_TIMELINE_REQUEST = 'FETCH_TWITTER_TIMELINE_REQUEST';
var FETCH_TWITTER_TIMELINE_SUCCESS = exports.FETCH_TWITTER_TIMELINE_SUCCESS = 'FETCH_TWITTER_TIMELINE_SUCCESS';
var FETCH_TWITTER_TIMELINE_FAILURE = exports.FETCH_TWITTER_TIMELINE_FAILURE = 'FETCH_TWITTER_TIMELINE_FAILURE';


/*****************
 ** WEBPACK FOOTER
 ** ./src/constants/action-types.js
 ** module id = 45
 ** module chunks = 0
 **/